export const CONTENT_SETTINGS_TYPE = {
  CAT: "CAT",
  SRC: "SRC",
};
